import React, { FC } from "react";

interface SolutionType {
    solutionTitle: string;
    solutionContent: string;
    solutionData: Array<string>;
}

const Solution: FC<SolutionType> = ({ solutionTitle, solutionContent, solutionData }) => {
    return (
        <section className="">
            <h2 className="casestudy-header font-normal">
                <span className="text-green-color font-bold">Solution Provided: </span>
                {solutionTitle}
            </h2>
            {solutionContent === "" ? (
                <ul>
                    {solutionData.map((list, index) => {
                        return (
                            <li className="content" key={index}>
                                {list}
                            </li>
                        );
                    })}
                </ul>
            ) : (
                <p className="content">{solutionContent}</p>
            )}
        </section>
    );
};

export default Solution;
